import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var MessageIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M12.14 44.76C11.9746 44.7614 11.8106 44.7296 11.6577 44.6666C11.5048 44.6037 11.366 44.5108 11.2495 44.3934C11.133 44.276 11.0412 44.1365 10.9795 43.983C10.9177 43.8296 10.8873 43.6654 10.89 43.5V36.78C9.14515 35.808 7.69078 34.3886 6.67664 32.6679C5.66249 30.9472 5.12519 28.9873 5.12 26.99V14.56C5.12264 12.0306 6.12859 9.60566 7.91711 7.81714C9.70564 6.02862 12.1306 5.02267 14.66 5.02002H33.53C36.0594 5.02267 38.4844 6.02862 40.2729 7.81714C42.0614 9.60566 43.0674 12.0306 43.07 14.56V28.63C43.0674 31.1594 42.0614 33.5843 40.2729 35.3729C38.4844 37.1614 36.0594 38.1673 33.53 38.17H24.68L12.68 44.61C12.5139 44.7009 12.3292 44.7522 12.14 44.76ZM14.69 7.52002C12.8375 7.53311 11.0646 8.27479 9.7547 9.58472C8.44477 10.8946 7.70309 12.6675 7.69 14.52V27C7.69504 28.6591 8.1727 30.2823 9.06708 31.6797C9.96146 33.077 11.2355 34.1907 12.74 34.89C12.9591 34.9889 13.1447 35.1492 13.2743 35.3516C13.4039 35.554 13.4719 35.7897 13.47 36.03V41.42L23.87 35.83C24.051 35.7314 24.2539 35.6798 24.46 35.68H33.63C35.4825 35.6669 37.2554 34.9252 38.5653 33.6153C39.8752 32.3054 40.6169 30.5325 40.63 28.68V14.56C40.6169 12.7075 39.8752 10.9346 38.5653 9.62469C37.2554 8.31477 35.4825 7.57309 33.63 7.56L14.69 7.52002Z"
  }));
});
MessageIcon.displayName = 'MessageIcon';
MessageIcon.defaultProps = {
  'aria-label': 'Message'
};
export default MessageIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/MessageIcon/index.js
// module id = 1892
// module chunks = 12